// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextArea_wrapper__8ra0o"};